import * as React from "react";
import { useRouter } from "next/router";
import { IChangeMsisdnOrchestrator } from "@nju/data-access-portal-orchestrator";
import { Button, Panel, Separator, Text } from "@nju/ui";
import { getChangeMsisdnStatusData } from "./utils";

interface IChangeMsisdnServiceBannerProps {
  orchestrator: IChangeMsisdnOrchestrator;
}

export function ChangeMsisdnServiceBanner({
  orchestrator,
}: IChangeMsisdnServiceBannerProps) {
  const { reload } = useRouter();

  const refresh = React.useCallback(() => {
    reload();
  }, [reload]);

  const panelProps = React.useMemo(() => {
    return getChangeMsisdnStatusData({ orchestrator });
  }, [orchestrator]);

  if (!panelProps) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  const { text, title, iconName } = panelProps;

  return (
    <Panel iconName={iconName} title={title}>
      <Separator size="xs" tone="invisible" />
      <Text
        size={{
          "@onlyMobile": "m",
          "@fromTablet": "l",
        }}
      >
        {text}
      </Text>
      <Separator size="xs" tone="invisible" />
      <div className="flex only-mobile:flex-col">
        <Button
          onPress={() => {
            refresh();
          }}
          size={{
            "@onlyMobile": "s",
          }}
        >
          odśwież
        </Button>
      </div>
    </Panel>
  );
}
